export default {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/interpolator/index.js
// module id = 52
// module chunks = 6